import { render, staticRenderFns } from "./AccordionsBlock.vue?vue&type=template&id=7323db9a&"
import script from "./AccordionsBlock.js?vue&type=script&lang=js&"
export * from "./AccordionsBlock.js?vue&type=script&lang=js&"
import style0 from "./AccordionsBlock.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports